import { render, staticRenderFns } from "./demoAccount.vue?vue&type=template&id=819d3938"
import script from "./demoAccount.vue?vue&type=script&lang=js"
export * from "./demoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports